import { useNavigate, useParams } from 'react-router-dom'
import { Button, Flex, Spinner, Text } from '../../Components'
import { saveEnvironment, useEnvironment } from './Functions'
import { useState } from 'react'
import { FloatInput } from '../../Components/Common/FloatInput'

export function Environment () {
  const { environmentId } = useParams()
  const navigate = useNavigate()
  const [environment, setEnvironment, isSuccess] = useEnvironment(environmentId)
  const { id = '' } = environment || {}
  const [checkError, setCheckError] = useState(false)

  const save = async () => {
    setCheckError(true)
    if (!environment.name) {
      // message e return per uscire dalla funzione
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Compila i campi mancanti' })
      return
    }
    setCheckError(false)

    const elaboratedEnvironment = { ...environment }
    const res = await saveEnvironment(elaboratedEnvironment)
    if (!res) return
    navigate('/environments/list')
  }

  const isNew = id === 'new'

  if (!isSuccess || !environment) return <Spinner />

  return (
    <Flex fw>
      <Text value={`${isNew ? 'Inserisci' : 'Modifica'} environment`} title bold size={30} />
      <Flex fw row wrap style={{ marginTop: 20 }}>
        <FloatInput
          value={[environment.name, (name) => setEnvironment('name', name)]}
          label='Nome' id='name' error={checkError && !environment.name}
          style={{ marginRight: 20, width: 250 }}
        />
        <FloatInput
          style={{ width: 200, marginRight: 20 }}
          value={[environment.codSociety, (codSociety) => setEnvironment('codSociety', codSociety)]}
          label='Codice Società' id='codSociety' error={checkError && !environment.codSociety}
        />
        <FloatInput
          style={{ width: 200 }}
          value={[environment.tomcatCode, (tomcatCode) => setEnvironment('tomcatCode', tomcatCode)]}
          label='Indentificativo Tomcat' id='tomcatCode' error={checkError && !environment.tomcatCode}
        />
      </Flex>
      <Flex fw row style={{ marginTop: 20 }}>
        <Button label='Salva' icon='fa-duotone fa-floppy-disk' style={{ marginRight: 10 }} onClick={save} />
        <Button label='Torna indietro' icon='fa-duotone fa-arrow-left' onClick={() => navigate('/environments/list')} />
      </Flex>
    </Flex>
  )
}
